export const estadoColor = { activo: '#10B981', moroso: '#F59E0B', suspendido: '#6366F1', inactivo_temporal: '#A855F7', retirado: '#6B7280' };
export const estadoBg = { activo: 'rgba(16,185,129,0.1)', moroso: 'rgba(245,158,11,0.1)', suspendido: 'rgba(99,102,241,0.1)', inactivo_temporal: 'rgba(168,85,247,0.1)', retirado: 'rgba(107,114,128,0.1)' };
export const formatCOP = (v) => v ? new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(v) : '—';

// `contraprestacion` arranca en false y no en '' a propósito: es una casilla, y una casilla
// con valor '' hace que React la trate como no controlada y avise por consola.
export const formVacio = { nombre: '', cedula: '', telefono: '', email: '', direccion: '', plan_id: '', dia_pago: '1', notas: '', estado: 'activo', fecha_instalacion: '', observaciones_instalacion: '', tipo_cliente: 'residencial', contraprestacion: false, motivo_contraprestacion: '', tecnologia_instalada: '', precio_especial: '', motivo_precio_especial: '', proveedor_red_id: '', mikrotik_tipo: 'ninguno', mikrotik_usuario: '', mikrotik_perfil: '', mikrotik_password: '', latitud: '', longitud: '', direccion_maps: '', ubicacion_origen: '' };

export const comprimirImagen = (archivo) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX = 1920;
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else { w = Math.round(w * MAX / h); h = MAX; }
        }
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const base64 = canvas.toDataURL('image/jpeg', 0.82).split(',')[1];
        resolve(base64);
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(archivo);
  });
};
